
import { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import { useNavigate } from "react-router";

import { Grid, Card, CardHeader, Typography, Divider, CardContent, FormControl, InputLabel, MenuItem, Select, Button, Chip, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Paper, CircularProgress, TextField, Box } from "@mui/material";

import UndoIcon from "@mui/icons-material/Undo";

import moment from 'moment';

import { DownloadFile } from "../../helpers/DownloadFile";
import { TablePaginationActions } from "../../helpers/TablePaginationActions";

import { usePages } from "../../hooks/usePages";

import { RootState } from "../../store";

import { TableTheadStyle, TablePaddingStyle } from "../../styles/TableStyle";

import { Layout } from "../../components/Layout";

import { DialogAmparo } from "../../dialogs/DialogAmparo";
import { DialogExpediente } from "../../dialogs/DialogExpediente";
import { DialogExhortoRecibido } from "../../dialogs/DialogExhortoRecibido";

import { ObtenerMateria } from '../../connections/catalogos/MateriaConnection';
import { ObtenerTipoAcuerdo } from "../../connections/catalogos/TipoAcuerdoConnection";
import { ObtenerSubTipoAcuerdo } from "../../connections/catalogos/SubTipoAcuerdoConnection";
import { ObtenerAutoridadesMaterias } from "../../connections/catalogos/AutoridadConnection";
import { BuscarUsuariosAcuerdo } from "../../connections/admin/UsuarioConnection";
import { ConsultaAcuerdosPendientes, DescargarAcuerdosPendientes } from "../../connections/tribunal/AcuerdoConnection";

import { MateriaProps } from "../../interfaces/catalogos/MateriaInterface";
import { UsuarioAcuerdoProps } from "../../interfaces/admin/UsuarioInterface";
import { AutoridadProps } from "../../interfaces/catalogos/AutoridadInterface";
import { TipoAcuerdoProps } from "../../interfaces/catalogos/TipoAcuerdoInterface";
import { SubTipoAcuerdoProps } from "../../interfaces/catalogos/SubTipoAcuerdoInterface";
import { defaultExpediente, ExpedienteProps } from "../../interfaces/recepcion/ExpedienteInterface";
import { defaultAmparo, AmparoProps } from "../../interfaces/recepcion/AmparoInterface";
import { defaultExhortoRecibido, ExhortoRecibidoProps } from "../../interfaces/recepcion/ExhortoRecibidoInterface";
import { ConsultaAcuerdosPendientesProps } from "../../interfaces/tribunal/AcuerdoInterface";

export const AcuerdosPendientesPage = () => {

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [loading, setLoading] = useState( false );
    const [loadingSearch, setLoadingSearch] = useState( false );
    const [loadingDescargar, setLoadingDescargar] = useState( false );

    const [openDialogExpediente, setOpenDialogExpediente] = useState( false );
    const [expedienteSeleccionado, setExpedienteSeleccionado] = useState<ExpedienteProps>( defaultExpediente );

    const [openDialogAmparo, setOpenDialogAmparo] = useState( false );
    const [amparoSeleccionado, setAmparoSeleccionado] = useState<AmparoProps>( defaultAmparo );

    const [openDialogExhortoRecibido, setOpenDialogExhortoRecibido] = useState( false );
    const [exhortoRecibidoSeleccionado, setExhortoRecibidoSeleccionado] = useState<ExhortoRecibidoProps>( defaultExhortoRecibido );

    const [recordCount, setRecordCount] = useState( 0 );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [tipoAcuerdo, setTipoAcuerdo] = useState( 0 );
    const [tipoAcuerdoArray, setTipoAcuerdoArray] = useState<TipoAcuerdoProps[]>( [] );

    const [subTipoAcuerdo, setSubTipoAcuerdo] = useState( 0 );
    const [subTipoAcuerdoArray, setSubTipoAcuerdoArray] = useState<SubTipoAcuerdoProps[]>( [] );

    const [usuarioAsignado, setUsuarioAsignado] = useState( 0 );
    const [usuarioArray, setUsuarioArray] = useState<UsuarioAcuerdoProps[]>( [] );

    const [numeroReferencia, setNumeroReferencia] = useState( '' );

    const [rows, setRows] = useState<ConsultaAcuerdosPendientesProps[]>( [] );

    const [filtroAplicado, setFiltroAplicado] = useState( false );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const handleClear = () => {

        setFiltroAplicado( false );

        setMateria( 0 );
        setAutoridad( 0 );
        setTipoAcuerdo( 0 );
        setSubTipoAcuerdo( 0 );
        setUsuarioAsignado( 0 );
        setNumeroReferencia( '' );

        setRows( [] );
        setRecordCount( 0 );

        resetPage();

    }

    const handleBuscar = async () => {

        setLoadingSearch( true );
        setFiltroAplicado( true );

        setRecordCount( 0 );

        resetPage();
    }

    const handleDescargar = async () => {

        setLoadingDescargar( true );

        await DescargarAcuerdosPendientes({
            idAutoridad: autoridad,
            idMateria: materia,
            numeroReferencia: numeroReferencia,
            idTipoAcuerdo: tipoAcuerdo,
            idSubTipoAcuerdo: subTipoAcuerdo,
            idUsuarioAsignado: usuarioAsignado
        }).then( resp => {

            if ( resp ) {

                setTimeout(() => {

                    DownloadFile( `Acuerdos-Pendientes-${ Date.now() }.xlsx`, resp );

                    setLoadingDescargar( false );

                }, 700);

            }

        });

    }

    const handleVerDetalle = ( { amparo, exhortoRecibido, expediente }: ConsultaAcuerdosPendientesProps ) => {

        if ( amparo.idAmparo !== 0 ) {
            setAmparoSeleccionado( amparo );
            setOpenDialogAmparo( true );
        }
        else if ( exhortoRecibido.idExhortoRecibido !== 0 ) {
            setExhortoRecibidoSeleccionado( exhortoRecibido );
            setOpenDialogExhortoRecibido( true );
        }
        else {
            setExpedienteSeleccionado( expediente );
            setOpenDialogExpediente( true );
        }

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then( resp => {
                setMateriaArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setAutoridad( 0 );
            setAutoridadArray( [] );

            await ObtenerAutoridadesMaterias( materia ).then( resp => {
                setAutoridadArray( resp );
            });

        }

        Obtener();

    }, [ materia ]);

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoAcuerdo().then( resp => {
                setTipoAcuerdoArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setSubTipoAcuerdo( 0 );
            setSubTipoAcuerdoArray( [] );

            if ( tipoAcuerdo !== 0 ) {

                await ObtenerSubTipoAcuerdo( tipoAcuerdo ).then( resp => {
                    setSubTipoAcuerdoArray( resp );
                });

            }

        }

        Obtener();

    }, [ tipoAcuerdo ]);

    useEffect(() => {

        async function Obtener() {

            await BuscarUsuariosAcuerdo().then( resp => {
                setUsuarioArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRows( [] );

            await ConsultaAcuerdosPendientes( { page, rowsPerPage, idAutoridad: 0, idMateria: 0, numeroReferencia: '', idTipoAcuerdo: 0, idSubTipoAcuerdo: 0, idUsuarioAsignado: 0 } ).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordsCount );
                    setRows( resp.records );
                    setLoadingSearch( false );
                    setLoading( false );

                }, 700);

            });

        }

        if ( !filtroAplicado ) {
            Obtener();
        }

    }, [ page, rowsPerPage, filtroAplicado ]);

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRows( [] );

            await ConsultaAcuerdosPendientes( { page, rowsPerPage, idAutoridad: autoridad, idMateria: materia, numeroReferencia: numeroReferencia, idTipoAcuerdo: tipoAcuerdo, idSubTipoAcuerdo: subTipoAcuerdo, idUsuarioAsignado: usuarioAsignado } ).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordsCount );
                    setRows( resp.records );
                    setLoadingSearch( false );
                    setLoading( false );

                }, 700);

            });

        }

        if ( filtroAplicado ) {
            Obtener();
        }

    }, [ page, rowsPerPage, filtroAplicado, materia, autoridad, tipoAcuerdo, subTipoAcuerdo, usuarioAsignado, numeroReferencia ]);

    return (
        <Layout breadcrumbs={ [{ text: 'Consultas' }, { text: 'Acuerdos pendientes' }] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                {
                    ( administrador || coordinador )
                    &&
                        <Grid size={{ md: 12, xs: 12 }} textAlign={ 'start' }>

                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate('/') }>
                                Regresar
                            </Button>

                        </Grid>
                }

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>
                        <CardHeader
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                            subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Filtro(s) </Typography> }
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 2, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Materia</InputLabel>
                                        <Select
                                            label='Materia'
                                            value={ materia }
                                            onChange={ (e) => setMateria( e.target.value ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                materiaArray
                                                .filter( ({ idMateria }) => idMateria === 5 || idMateria === 6 )
                                                .map(({ idMateria, descripcion }) => (
                                                    <MenuItem key={ idMateria } value={ idMateria }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Autoridad</InputLabel>
                                        <Select
                                            label="Autoridad"
                                            value={ autoridad }
                                            onChange={ (e) => setAutoridad( e.target.value ) }
                                            disabled={ filtroAplicado || materia === 0 }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                autoridadArray.map( ({ idAutoridad, descripcion }) => (
                                                    <MenuItem key={ idAutoridad } value={ idAutoridad }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Tipo de acuerdo</InputLabel>
                                        <Select
                                            label="Tipo de acuerdo"
                                            value={ tipoAcuerdo }
                                            onChange={ (e) => setTipoAcuerdo( e.target.value ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                tipoAcuerdoArray.map( ({ idTipoAcuerdo, descripcion }) => (
                                                    <MenuItem key={ idTipoAcuerdo } value={ idTipoAcuerdo }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Subtipo de acuerdo</InputLabel>
                                        <Select
                                            label="Subtipo de acuerdo"
                                            value={ subTipoAcuerdo }
                                            onChange={ (e) => setSubTipoAcuerdo( e.target.value ) }
                                            disabled={ filtroAplicado || tipoAcuerdo === 0 || subTipoAcuerdoArray.length === 0 }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                subTipoAcuerdoArray.map( ({ idSubTipoAcuerdo, descripcion }) => (
                                                    <MenuItem key={ idSubTipoAcuerdo } value={ idSubTipoAcuerdo }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>
                                    <TextField
                                        fullWidth
                                        label='Número de referencia'
                                        placeholder={ `1/${ new Date().getFullYear() }` }
                                        autoComplete='off'
                                        variant='outlined'
                                        value={ numeroReferencia }
                                        onChange={ (e) => setNumeroReferencia(e.target.value) }
                                        disabled={ filtroAplicado }
                                        slotProps={{
                                            input: { autoComplete: 'off' },
                                            inputLabel: { shrink: true }
                                        }}
                                    />
                                </Grid>

                                <Grid size={{ md: 7, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Asignado a</InputLabel>
                                        <Select
                                            label="Asignado a"
                                            value={ usuarioAsignado }
                                            onChange={ (e) => setUsuarioAsignado( e.target.value ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                usuarioArray.map( ({ id, nombreCompleto }) => (
                                                    <MenuItem key={ id } value={ id }>{ nombreCompleto }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <Button
                                        fullWidth
                                        color={ filtroAplicado ? 'secondary' : 'primary' }
                                        variant={ filtroAplicado ? 'outlined' : 'contained' }
                                        loading={ loadingSearch }
                                        disabled={ materia === 0 && autoridad === 0 && usuarioAsignado === 0 && numeroReferencia === '' && tipoAcuerdo === 0 && subTipoAcuerdo === 0 }
                                        onClick={ () => { filtroAplicado ? handleClear() : handleBuscar() } }
                                        sx={{ mt: 1, px: 5 }}
                                    >
                                        { filtroAplicado ? 'Limpiar filtro' : 'Buscar' }
                                    </Button>

                                </Grid>

                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }} textAlign={ 'right' }>

                    <Button
                        color='secondary'
                        variant="outlined"
                        sx={{ mt: 1 }}
                        loading={ loadingDescargar }
                        disabled={ rows.length === 0 }
                        onClick={ handleDescargar }
                    >
                        Descargar información
                    </Button>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }}>

                    <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                        <Table sx={{ minWidth: 500 }}>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}></TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Referencia</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}>Tipo de trámite</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold' }}>Tipo de acuerdo</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold' }}>Asignado a</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold', textAlign: 'center' }}>Estatus / Duración</TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    rows
                                    .map( ( row, index ) => {

                                        const { numeroSeguimiento, fecha, referencia, noReferencia, tipoTramite, tipoAcuerdo, subTipoAcuerdo, usuarioAsignado, diasTranscurridos, idEstatus, estatus } = row;

                                        return (

                                        <TableRow key={ index }>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Typography variant='h6'>
                                                    { numeroSeguimiento }
                                                </Typography>

                                                {
                                                    fecha
                                                    &&
                                                        <>

                                                            <Typography variant='subtitle1' fontSize={ 14 }>
                                                                { moment( fecha ).format( 'DD-MM-YYYY' ) }
                                                            </Typography>

                                                            <Typography variant='caption' color='text.secondary'>
                                                                { moment( fecha ).format( 'hh:mm a' ) }
                                                            </Typography>

                                                        </>
                                                }

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>

                                                    <Button
                                                        fullWidth
                                                        variant='contained'
                                                        onClick={ () => handleVerDetalle( row ) }
                                                    >
                                                        { referencia }
                                                    </Button>

                                                    { noReferencia && <Typography variant='caption' color="text.secondary" mt={ 1 }>{ noReferencia }</Typography> }

                                                </Box>

                                            </TableCell>

                                            <TableCell>

                                                <Typography variant='subtitle1' fontSize={ 14 }>
                                                    { tipoTramite }
                                                </Typography>

                                            </TableCell>

                                            <TableCell>

                                                {
                                                    subTipoAcuerdo
                                                    ?
                                                        <>
                                                            <Typography variant='subtitle1' fontWeight='bold'>{ tipoAcuerdo }</Typography>
                                                            <Typography variant='subtitle2' color='textSecondary' fontSize={ 12 }>({ subTipoAcuerdo })</Typography>
                                                        </>
                                                    :
                                                        <Typography variant='subtitle1' fontWeight='bold'>{ tipoAcuerdo }</Typography>
                                                }

                                            </TableCell>

                                            <TableCell>

                                                <Typography variant='subtitle1' fontSize={ 14 }>
                                                    { usuarioAsignado }
                                                </Typography>

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Chip
                                                    variant='filled'
                                                    sx={{ fontWeight: 'bold', px: idEstatus === 3 ? 0 : 3, py: idEstatus === 3 ? 0 : 4 }}
                                                    color={ idEstatus === 3 ? 'primary' : 'default' }
                                                    label={
                                                        idEstatus === 3
                                                        ?
                                                            <Typography variant='subtitle1' fontWeight={ '600' } fontSize={ 14 }>
                                                                { estatus }
                                                            </Typography>
                                                        :
                                                            <>
                                                                <Typography variant='subtitle1' fontSize={ 14 }>
                                                                    <strong>{ estatus }</strong>
                                                                </Typography>
                                                                {
                                                                    diasTranscurridos !== 0 && <Typography variant='subtitle1' fontSize={ 14 }>{ diasTranscurridos } día(s) </Typography>
                                                                }
                                                            </>
                                                    }
                                                />

                                            </TableCell>

                                        </TableRow>

                                    )})
                                }

                                {
                                    ( rows.length === 0 && !loading )
                                    ?
                                        <TableRow style={{ height: 100 }}>
                                            <TableCell colSpan={ 6 } align="center">
                                                <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                            </TableCell>
                                        </TableRow>
                                    :
                                        loading
                                        &&
                                            <TableRow style={{ height: 100 }}>
                                                <TableCell colSpan={ 6 } align="center">
                                                    <CircularProgress size={ 26 } />
                                                </TableCell>
                                            </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={ 2 }>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { recordCount } </Typography>
                                    </TableCell>

                                    <TablePagination
                                        rowsPerPageOptions={[ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ]}
                                        colSpan={ 4 }
                                        count={ recordCount }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }
                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage="Filas por página"
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                                return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

            </Grid>

            <DialogExpediente
                expediente={ expedienteSeleccionado }
                openDialog={ openDialogExpediente }
                handleCloseDialog={ () => setOpenDialogExpediente( false ) }
            />

            <DialogAmparo
                amparo={ amparoSeleccionado }
                openDialog={ openDialogAmparo }
                handleCloseDialog={ () => setOpenDialogAmparo( false ) }
            />

            <DialogExhortoRecibido
                exhortoRecibido={ exhortoRecibidoSeleccionado }
                openDialog={ openDialogExhortoRecibido }
                handleCloseDialog={ () => setOpenDialogExhortoRecibido( false ) }
            />

        </Layout>
    )
}
